export const maskIdentifier = (id) => {
  const maxLength = 20; // Adjust max length if needed

  if (id.includes("@")) {
    const [username, domain] = id.split("@");

    if (username.length > 5) {
      return `${username.slice(0, 3)}***${username.slice(-2)}@${domain}`;
    }

    return `${username[0]}***@${domain}`; // If username is too short, keep at least 1 char
  }

  // For non-email identifiers, mask middle and keep last 4 characters visible
  if (id.length > maxLength) {
    return `${id.slice(0, 4)}***${id.slice(-4)}`;
  }

  return id;
};
